"use client";

import classes from "./ProductWithThreeBanner.module.css";

import Image from "next/image";

import ProductCard from "@/components/ProductCard";
import { useLogicalProductsWithInterceptors } from "@/hooks/useLogicalProducts";
import { getSectionStyle } from "@/utils";
import { getPageRoute, getS3ImageUrl } from "@/utils/routes";
import Link from "next/link";
import { useRef } from "react";
import { ProductRowSkeletonFour } from "../skeleton";

const ProductWithThreeBanner = ({
	widget,
	initialProducts,
}: {
	widget?: Widget;
	initialProducts?: ProductItem[];
}) => {
	const mainRef = useRef(null);
	const { products, loading, error } = useLogicalProductsWithInterceptors({
		widget,
		ref: mainRef,
		initialProducts,
	});

	const banner1 = widget?.data?.rightImages?.rightImageOne;
	const banner2 = widget?.data?.rightImages?.rightImageTwo;
	const featuredBanner: WidgetImage = {
		image: widget?.featuredImage || "",
		link: (widget as any)?.fetchuredImageUrl || {},
	};

	if (!products?.length && !loading) return null;

	const settings = widget?.data?.settings || {};

	return (
		<section
			className={classes.ProductWithThreeBanner}
			ref={mainRef}
			style={getSectionStyle(settings)}>
			<div className="container">
				<div className={classes.body}>
					<div className="xl:flex gap-2 mb-2 xl:mb-4">
						<div className={classes.products}>
							{products.slice(0, 4).map((product, i) => (
								<ProductCard
									key={i}
									productItem={product}
									type="lg"
								/>
							))}
						</div>

						{loading && (
							<div className="grid flex-1">
								<ProductRowSkeletonFour />
							</div>
						)}

						<div className={classes.banners}>
							{[banner1, banner2].map((banner, i) => (
								<Link
									key={i}
									className={classes.banner}
									href={getPageRoute(
										banner?.link?.urlType || "custom",
										banner?.link?.url || ""
									)}
									title={banner?.link?.hyperLinkText || ""}>
									<Image
										src={getS3ImageUrl(banner?.image || "")}
										alt={banner?.link?.hyperLinkText || " banner image"}
										layout="responsive"
										unoptimized={true}
										width={315}
										height={200}
										style={{
											aspectRatio: 315 / 200,
											objectFit: "cover",
											// height: `${pHeight / 2}px`,
										}}
									/>
								</Link>
							))}
						</div>
					</div>

					<Link
						className={classes.banner}
						href={getPageRoute(
							featuredBanner?.link?.urlType || "custom",
							featuredBanner?.link?.url || ""
						)}
						title={featuredBanner?.link?.hyperLinkText || ""}>
						<Image
							src={getS3ImageUrl(featuredBanner?.image || "")}
							alt="banner"
							layout="responsive"
							width={1320}
							height={355}
							unoptimized={true}
							style={{
								aspectRatio: 1320 / 355,
								objectFit: "cover",
							}}
						/>
					</Link>
				</div>
			</div>
		</section>
	);
};

export default ProductWithThreeBanner;
